import { render, staticRenderFns } from "./BooleanRadioField.vue?vue&type=template&id=ed864b98&"
import script from "./BooleanRadioField.vue?vue&type=script&lang=js&"
export * from "./BooleanRadioField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports